import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.css']
})
export class EmailPreviewComponent implements OnInit {
  @Input() data;
  config;
  currentEmail;
  currentIndex: number = 0;
  fromManageUsers = false;
  manualEmail = true;

  ngOnInit() {
    this.manualEmail = this.data?.data?.manualEmail;
    this.config = this.data?.data?.emailPreviewData;
    this.fromManageUsers = this.data?.fromManageUsers;
    this.currentEmail = this.getCurrentEmail();
  }

  getCurrentEmail() {
    this.currentEmail = this.config[this.currentIndex];
    return this.currentEmail
  }

  onNextClick() {
    this.currentIndex++;
    if (this.currentIndex > this.config.length - 1) {
      this.currentIndex = 0;
    }
    this.getCurrentEmail();

  }

  onPreviousClick() {
    this.currentIndex--;
    if (this.currentIndex < 0) {
      this.currentIndex = this.config.length - 1;
    }
    this.getCurrentEmail();
  }

}
